import { Type } from 'class-transformer';
import { IsArray, IsNotEmpty, IsOptional, IsUUID } from 'class-validator';

export class AddRoleFormDto {
  @IsUUID()
  @IsNotEmpty({
    message: 'Обязательное поле',
    groups: ['form'],
  })
  userId: string;

  @IsArray()
  @IsOptional()
  @Type(() => String)
  profiles?: string[];
}
